// Chefs & Bakers: staggered scroll reveals
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.cb-reveal').forEach(el => el.classList.add('in'));
    return;
  }
  document.querySelectorAll('.cb-cats, .cb-prods, .cb-locs, .cb-pillars').forEach(grid => {
    grid.querySelectorAll('.cb-reveal').forEach((el, i) => el.style.setProperty('--d', (i % 6) * 0.07 + 's'));
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.cb-reveal').forEach(el => io.observe(el));
})();

// Oatbedient Orders: a lightweight, keyboard-friendly product matching game.
(function () {
  document.querySelectorAll('[data-oat-game]').forEach(function (game) {
    var screens = {
      welcome: game.querySelector('[data-oat-game-screen="welcome"]'),
      play: game.querySelector('[data-oat-game-screen="play"]'),
      result: game.querySelector('[data-oat-game-screen="result"]')
    };
    var startButton = game.querySelector('[data-oat-game-start]');
    var restartButton = game.querySelector('[data-oat-game-restart]');
    var facebookShareButton = game.querySelector('[data-oat-game-share-facebook]');
    var instagramShareButton = game.querySelector('[data-oat-game-share-instagram]');
    var choices = Array.from(game.querySelectorAll('[data-oat-game-choice]'));
    if (!screens.welcome || !screens.play || !screens.result || !startButton || !choices.length) return;

    var orders = [
      {
        kicker: 'The fuller café order',
        prompt: 'The order needs reliable latte-art foam and a fuller body, not the lighter member of the Barista pair.',
        answer: 'barista',
        explain: 'Barista is the richer, creamier blend made to froth beautifully.'
      },
      {
        kicker: 'Keep the base subtle',
        prompt: 'An iced tea needs the lighter, smoother Barista option so the drink stays delicate rather than foam-forward.',
        answer: 'artisan',
        explain: 'Artisan Barista is the lighter, smoother member of the two Barista options.'
      },
      {
        kicker: 'Dessert without the oil',
        prompt: 'The customer wants an indulgent cocoa drink made without added oil.',
        answer: 'chocolate',
        explain: 'Chocolate brings the velvety cocoa flavour, with no added oil.'
      },
      {
        kicker: 'Shortest ingredient list',
        prompt: 'Choose the formula where three purposeful ingredients and natural oat sweetness do all the work.',
        answer: 'zero',
        explain: 'Zero has only three ingredients, with no added oil and no added sugar.'
      },
      {
        kicker: 'Foam first',
        prompt: 'This carton must hold silky microfoam for latte art. Pick the café-performance blend.',
        answer: 'barista',
        explain: 'Barista is the foam-first café choice for silky microfoam and latte art.'
      },
      {
        kicker: 'Keep it easy-going',
        prompt: 'Pick the easy-going Barista option with a lighter finish, not the richer foam-first one.',
        answer: 'artisan',
        explain: 'That lighter, easy-going finish points only to Artisan Barista.'
      },
      {
        kicker: 'Velvety indulgence',
        prompt: 'The clue is a creamy oat drink swirled with rich chocolate, made for a cheeky everyday treat.',
        answer: 'chocolate',
        explain: 'A rich chocolate swirl is the unmistakable Chocolate clue.'
      },
      {
        kicker: 'Nothing added',
        prompt: 'The customer wants natural oat sweetness without added sugar or added oil.',
        answer: 'zero',
        explain: 'No added sugar and no added oil together point to Zero.'
      },
      {
        kicker: 'Fuller-bodied',
        prompt: 'Select the fuller-bodied member of Oatbedient’s two Barista options.',
        answer: 'barista',
        explain: 'Barista is the fuller, richer half of the Barista pair.'
      },
      {
        kicker: 'A quiet all-rounder',
        prompt: 'The note says smooth, light, and versatile, then specifically rules out the richer foam-first carton.',
        answer: 'artisan',
        explain: 'Smooth, light, and versatile describes Artisan Barista.'
      },
      {
        kicker: 'One non-negotiable flavour',
        prompt: 'Cocoa flavour is the non-negotiable clue, but added oil is not invited.',
        answer: 'chocolate',
        explain: 'Chocolate is the cocoa-forward option and contains no added oil.'
      },
      {
        kicker: 'The simplest oat order',
        prompt: 'The order asks for the simplest oat option: three ingredients and natural oatsome sweetness.',
        answer: 'zero',
        explain: 'Three ingredients and natural oat sweetness identify Zero.'
      },
      {
        kicker: 'Café texture',
        prompt: 'The bar lead wants the creamier Barista option with the strongest frothing performance.',
        answer: 'barista',
        explain: 'The creamier, stronger-frothing option is Barista.'
      },
      {
        kicker: 'From cereal to iced tea',
        prompt: 'The order needs a versatile Barista with a lighter body that will not overpower everyday drinks.',
        answer: 'artisan',
        explain: 'A lighter body and easy smoothness identify Artisan Barista.'
      },
      {
        kicker: 'The cheeky break',
        prompt: 'Choose the velvety treat whose defining flavour is neither plain oat nor added sweetness alone.',
        answer: 'chocolate',
        explain: 'The luscious cocoa treat belongs to Chocolate.'
      },
      {
        kicker: 'Purposefully simple',
        prompt: 'This order wants the clean formula where natural oat sweetness does all the work.',
        answer: 'zero',
        explain: 'The clean formula with natural oat sweetness is Zero.'
      },
      {
        kicker: 'Latte art duty',
        prompt: 'A café needs the richer oat milk designed to stretch into glossy foam for latte art.',
        answer: 'barista',
        explain: 'Glossy café foam and a richer texture point to Barista.'
      },
      {
        kicker: 'Smooth, not rich',
        prompt: 'The note says lighter and smoother, specifically not the richer member of the Barista pair.',
        answer: 'artisan',
        explain: 'The lighter member of the pair is Artisan Barista.'
      },
      {
        kicker: 'No-oil indulgence',
        prompt: 'The customer wants a velvety chocolate indulgence made without added oil.',
        answer: 'chocolate',
        explain: 'Velvety chocolate with no added oil identifies Chocolate.'
      },
      {
        kicker: 'Nothing unnecessary',
        prompt: 'Find the only carton that satisfies all three limits at once: no added oil, no added sugar, and three ingredients.',
        answer: 'zero',
        explain: 'Those three requirements point only to Zero.'
      }
    ];
    var praise = {
      barista: 'Foam secured.',
      artisan: 'Light and smooth.',
      chocolate: 'Chocolate craving handled.',
      zero: 'Clean and simple.'
    };
    var rewards = [
      'Your cartons stayed in line. Very Oatbedient.',
      'Oat-standing work. The café is officially happy.',
      'Smooth route, smart matches, excellent oat behavior.',
      'Every oat found its moment. Mission complete.'
    ];
    var answerNames = {
      barista: 'Barista',
      artisan: 'Artisan Barista',
      chocolate: 'Chocolate',
      zero: 'Zero'
    };
    var routeTarget = 2400;
    var arrivalBonus = 500;
    var routeMilestones = [
      { score: 600, message: 'First checkpoint glowing. Oat-standing start!' },
      { score: 1200, message: 'Foam Flow unlocked. You are halfway to the café!' },
      { score: 1800, message: 'Café Bound unlocked. One smooth final stretch!' }
    ];
    var state = { running: false, arrived: false, time: 45, score: 0, streak: 0, bestStreak: 0, milestones: 0, index: 0, current: null, queue: [] };
    var timer = null;
    var nextTimer = null;
    var milestoneTimer = null;
    var audioContext = null;
    var musicTimer = null;
    var musicStep = 0;
    var soundEnabled = true;
    var useMediaAudio = typeof Audio !== 'undefined';
    var mediaAudio = {};
    var timeNode = game.querySelector('[data-oat-game-time]');
    var scoreNode = game.querySelector('[data-oat-game-score]');
    var streakNode = game.querySelector('[data-oat-game-streak]');
    var kickerNode = game.querySelector('[data-oat-game-kicker]');
    var promptNode = game.querySelector('[data-oat-game-prompt]');
    var ticket = game.querySelector('[data-oat-game-ticket]');
    var clueNode = game.querySelector('[data-oat-game-clue]');
    var clueArt = clueNode ? clueNode.closest('.oat-game__clue-art') : null;
    var clueLabel = game.querySelector('[data-oat-game-clue-label]');
    var feedback = game.querySelector('[data-oat-game-feedback]');
    var rider = game.querySelector('[data-oat-game-rider]');
    var routeFinish = game.querySelector('[data-oat-game-finish]');
    var routeStops = Array.from(game.querySelectorAll('[data-oat-game-checkpoint]'));
    var routeCheer = game.querySelector('[data-oat-game-route-cheer]');
    var soundButton = game.querySelector('[data-oat-game-sound]');
    var soundLabel = game.querySelector('[data-oat-game-sound-label]');
    var resultTitle = game.querySelector('[data-oat-game-result-title]');
    var finalScore = game.querySelector('[data-oat-game-final-score]');
    var bestStreak = game.querySelector('[data-oat-game-best-streak]');
    var reward = game.querySelector('[data-oat-game-reward]');
    var personalBest = game.querySelector('[data-oat-game-personal-best]');
    var confetti = game.querySelector('[data-oat-game-confetti]');
    var shareStatus = game.querySelector('[data-oat-game-share-status]');
    var arrivalBadge = game.querySelector('[data-oat-game-arrival]');
    var resultMascot = game.querySelector('[data-oat-game-result-mascot]');
    var clueImages = {
      barista: game.getAttribute('data-oat-game-clue-barista'),
      artisan: game.getAttribute('data-oat-game-clue-artisan'),
      chocolate: game.getAttribute('data-oat-game-clue-chocolate'),
      zero: game.getAttribute('data-oat-game-clue-zero')
    };
    try { soundEnabled = localStorage.getItem('cb-oat-game-sound') !== 'off'; } catch (error) {}

    if (useMediaAudio) {
      ['loop', 'start', 'correct', 'wrong', 'arrival'].forEach(function (name) {
        var source = game.getAttribute('data-oat-game-audio-' + name);
        if (!source) return;
        var audio = new Audio(source);
        audio.preload = 'auto';
        audio.playsInline = true;
        audio.volume = name === 'loop' ? .32 : .72;
        audio.loop = name === 'loop';
        audio.load();
        mediaAudio[name] = audio;
      });
    }

    function shuffledOrders() {
      var copy = orders.slice();
      for (var i = copy.length - 1; i > 0; i -= 1) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = copy[i]; copy[i] = copy[j]; copy[j] = temp;
      }
      return copy;
    }

    function syncSoundUI() {
      if (!soundButton) return;
      soundButton.setAttribute('aria-pressed', soundEnabled ? 'true' : 'false');
      if (soundLabel) soundLabel.textContent = soundEnabled ? 'On' : 'Off';
    }

    function ensureAudio() {
      if (!soundEnabled) return null;
      var AudioEngine = window.AudioContext || window.webkitAudioContext;
      if (!AudioEngine) return null;
      if (!audioContext) audioContext = new AudioEngine();
      if (audioContext.state === 'suspended') audioContext.resume().catch(function () {});
      return audioContext;
    }

    function unlockAudio() {
      var context = ensureAudio();
      if (!context) return Promise.resolve(null);
      try {
        var buffer = context.createBuffer(1, 1, 22050);
        var source = context.createBufferSource();
        source.buffer = buffer;
        source.connect(context.destination);
        source.start(0);
      } catch (error) {}
      if (context.state === 'running') return Promise.resolve(context);
      return context.resume().then(function () { return context; }).catch(function () { return null; });
    }

    function playTone(frequency, duration, volume, delay, type) {
      var context = ensureAudio();
      if (!context) return;
      var start = context.currentTime + (delay || 0);
      var oscillator = context.createOscillator();
      var gain = context.createGain();
      oscillator.type = type || 'triangle';
      oscillator.frequency.setValueAtTime(frequency, start);
      gain.gain.setValueAtTime(.0001, start);
      gain.gain.exponentialRampToValueAtTime(volume, start + .018);
      gain.gain.exponentialRampToValueAtTime(.0001, start + duration);
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start(start);
      oscillator.stop(start + duration + .02);
    }

    function playCue(name) {
      if (!soundEnabled) return;
      if (useMediaAudio && mediaAudio[name]) {
        try {
          mediaAudio[name].currentTime = 0;
          mediaAudio[name].play().catch(function () {});
        } catch (error) {}
        return;
      }
      if (name === 'start') {
        playTone(659.25, .18, .11, 0, 'sine');
        playTone(880, .26, .09, .12, 'triangle');
      } else if (name === 'correct') {
        playTone(783.99, .13, .1, 0, 'triangle');
        playTone(1046.5, .22, .09, .09, 'sine');
      } else if (name === 'wrong') {
        playTone(246.94, .18, .07, 0, 'triangle');
        playTone(196, .22, .06, .1, 'sine');
      } else if (name === 'arrival') {
        playTone(659.25, .18, .12, 0, 'triangle');
        playTone(783.99, .2, .11, .11, 'triangle');
        playTone(1046.5, .42, .12, .22, 'sine');
      }
    }

    function musicTick() {
      if (!state.running || !soundEnabled || document.hidden) return;
      var notes = [392, 523.25, 659.25, 523.25, 440, 587.33, 659.25, 0];
      var note = notes[musicStep % notes.length];
      musicStep += 1;
      if (note) playTone(note, .16, .028, 0, 'triangle');
    }

    function startMusic() {
      if (!soundEnabled || musicTimer || document.hidden) return;
      if (useMediaAudio && mediaAudio.loop) {
        try {
          mediaAudio.loop.currentTime = 0;
          mediaAudio.loop.play().catch(function () {});
        } catch (error) {}
        return;
      }
      ensureAudio();
      musicStep = 0;
      musicTick();
      musicTimer = setInterval(musicTick, 560);
    }

    function stopMusic() {
      if (useMediaAudio && mediaAudio.loop) {
        mediaAudio.loop.pause();
        mediaAudio.loop.currentTime = 0;
      }
      clearInterval(musicTimer);
      musicTimer = null;
    }

    syncSoundUI();
    if (soundButton && !useMediaAudio && !(window.AudioContext || window.webkitAudioContext)) soundButton.hidden = true;
    if (soundButton) {
      soundButton.addEventListener('click', function () {
        soundEnabled = !soundEnabled;
        try { localStorage.setItem('cb-oat-game-sound', soundEnabled ? 'on' : 'off'); } catch (error) {}
        syncSoundUI();
        if (soundEnabled) {
          if (useMediaAudio) {
            playCue('start');
            if (state.running) startMusic();
          } else {
            unlockAudio().then(function () {
              playCue('start');
              if (state.running) startMusic();
            });
          }
        } else {
          stopMusic();
        }
      });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopMusic();
      else if (state.running && soundEnabled) startMusic();
    });

    function showScreen(name) {
      Object.keys(screens).forEach(function (key) { screens[key].hidden = key !== name; });
      game.setAttribute('data-oat-game-state', name);
    }

    function updateHud() {
      timeNode.textContent = state.time;
      scoreNode.textContent = state.score;
      streakNode.textContent = state.streak;
      var route = Math.min(94, Math.max(4, 4 + ((state.score / routeTarget) * 90)));
      game.style.setProperty('--oat-route', route + '%');
      if (rider) rider.style.left = 'var(--oat-route)';
      var reached = routeMilestones.filter(function (milestone) {
        return state.score >= milestone.score;
      }).length;
      if (reached > state.milestones) {
        state.milestones = reached;
        var activeIndex = reached - 1;
        var activeStop = routeStops[activeIndex];
        routeStops.forEach(function (stop, index) {
          stop.classList.toggle('is-passed', index < reached);
          stop.classList.toggle('is-celebrating', index === activeIndex);
        });
        if (routeCheer) {
          clearTimeout(milestoneTimer);
          routeCheer.textContent = routeMilestones[activeIndex].message;
          routeCheer.classList.remove('is-showing');
          void routeCheer.offsetWidth;
          routeCheer.classList.add('is-showing');
          milestoneTimer = setTimeout(function () {
            routeCheer.classList.remove('is-showing');
            if (activeStop) activeStop.classList.remove('is-celebrating');
          }, 2100);
        }
      }
    }

    function setChoicesDisabled(disabled) {
      choices.forEach(function (choice) { choice.disabled = disabled; });
    }

    function nextOrder() {
      if (!state.running) return;
      if (!state.queue.length) state.queue = shuffledOrders();
      state.current = state.queue.shift();
      kickerNode.textContent = state.current.kicker;
      promptNode.textContent = state.current.prompt;
      if (clueNode && clueImages[state.current.answer]) clueNode.src = clueImages[state.current.answer];
      if (clueArt) clueArt.classList.remove('is-revealed');
      if (clueLabel) clueLabel.textContent = 'Answer reveals here';
      feedback.textContent = 'Order ready. Choose its oat mood.';
      ticket.classList.remove('is-arriving');
      void ticket.offsetWidth;
      ticket.classList.add('is-arriving');
      setChoicesDisabled(false);
    }

    function getTitle(score) {
      if (state.arrived) return 'Café Route Champion';
      if (score >= 2400) return 'Master of the Carton';
      if (score >= 1500) return 'Oat Route Operator';
      if (score >= 700) return 'Foam Streak Finder';
      return 'Oat Rookie on the Rise';
    }

    function addConfetti() {
      if (!confetti) return;
      confetti.innerHTML = '';
      var colors = ['#de9526', '#365b7f', '#74cbbb', '#a55d36', '#f7f1e5'];
      for (var i = 0; i < 14; i += 1) {
        var piece = document.createElement('i');
        piece.style.setProperty('--x', (8 + Math.random() * 84) + '%');
        piece.style.setProperty('--delay', (Math.random() * .45) + 's');
        piece.style.setProperty('--spin', ((Math.random() * 220) - 110) + 'deg');
        piece.style.background = colors[i % colors.length];
        confetti.appendChild(piece);
      }
    }

    function finishGame() {
      if (!state.running) return;
      state.running = false;
      clearInterval(timer);
      clearTimeout(nextTimer);
      clearTimeout(milestoneTimer);
      stopMusic();
      setChoicesDisabled(true);
      var title = getTitle(state.score);
      var storedBest = 0;
      try { storedBest = Number(localStorage.getItem('cb-oat-game-best') || 0); } catch (error) {}
      var newBest = Math.max(storedBest, state.score);
      try { localStorage.setItem('cb-oat-game-best', String(newBest)); } catch (error) {}
      resultTitle.textContent = title;
      finalScore.textContent = state.score;
      bestStreak.textContent = state.bestStreak;
      personalBest.textContent = newBest;
      reward.textContent = state.arrived
        ? 'Oatdit reached the café with time to spare. Oat-standing delivery!'
        : rewards[Math.floor(Math.random() * rewards.length)];
      if (arrivalBadge) arrivalBadge.hidden = !state.arrived;
      shareStatus.textContent = '';
      showScreen('result');
      addConfetti();
      resultTitle.focus();
    }

    function chooseVariant(choice) {
      if (!state.running || !state.current || choice.disabled) return;
      setChoicesDisabled(true);
      var selected = choice.getAttribute('data-oat-game-choice');
      var correct = selected === state.current.answer;
      if (clueArt) clueArt.classList.add('is-revealed');
      if (clueLabel) clueLabel.textContent = 'Correct: ' + answerNames[state.current.answer];
      choices.forEach(function (item) {
        item.classList.remove('is-correct', 'is-wrong');
        if (item.getAttribute('data-oat-game-choice') === state.current.answer) item.classList.add('is-correct');
      });
      if (correct) {
        state.streak += 1;
        state.bestStreak = Math.max(state.bestStreak, state.streak);
        state.score += 100 + Math.min(100, (state.streak - 1) * 10);
        feedback.textContent = praise[selected] + ' ' + state.current.explain + (state.streak >= 3 ? ' Foam Streak ×' + state.streak + '!' : '');
        game.classList.remove('is-wrong');
        game.classList.add('is-correct');
        playCue('correct');
      } else {
        state.streak = 0;
        state.score = Math.max(0, state.score - 25);
        choice.classList.add('is-wrong');
        feedback.textContent = 'Not quite. ' + state.current.explain + ' The right carton is highlighted.';
        game.classList.remove('is-correct');
        game.classList.add('is-wrong');
        playCue('wrong');
      }
      updateHud();
      if (correct && !state.arrived && state.score >= routeTarget) {
        state.arrived = true;
        state.score += arrivalBonus;
        updateHud();
        feedback.textContent = 'Café reached! Oatdit delivered every order and earned a +500 café arrival bonus.';
        game.classList.add('has-arrived');
        if (routeFinish) routeFinish.textContent = 'Delivered!';
        playCue('arrival');
        stopMusic();
        clearTimeout(nextTimer);
        nextTimer = setTimeout(finishGame, 1300);
        return;
      }
      clearTimeout(nextTimer);
      nextTimer = setTimeout(function () {
        game.classList.remove('is-correct', 'is-wrong');
        choices.forEach(function (item) { item.classList.remove('is-correct', 'is-wrong'); });
        nextOrder();
      }, 1450);
    }

    function startGame() {
      clearInterval(timer);
      clearTimeout(nextTimer);
      clearTimeout(milestoneTimer);
      state.running = true;
      state.arrived = false;
      state.time = 45;
      state.score = 0;
      state.streak = 0;
      state.bestStreak = 0;
      state.milestones = 0;
      state.queue = shuffledOrders();
      game.classList.remove('has-arrived', 'is-correct', 'is-wrong');
      routeStops.forEach(function (stop) { stop.classList.remove('is-passed', 'is-celebrating'); });
      if (routeCheer) {
        routeCheer.textContent = '';
        routeCheer.classList.remove('is-showing');
      }
      if (routeFinish) routeFinish.textContent = 'Café!';
      if (arrivalBadge) arrivalBadge.hidden = true;
      game.style.setProperty('--oat-route', '4%');
      showScreen('play');
      updateHud();
      nextOrder();
      choices[0].focus();
      if (useMediaAudio) {
        playCue('start');
        startMusic();
      } else {
        unlockAudio().then(function () {
          if (!state.running || !soundEnabled) return;
          playCue('start');
          startMusic();
        });
      }
      timer = setInterval(function () {
        state.time -= 1;
        updateHud();
        if (state.time <= 0) finishGame();
      }, 1000);
    }

    startButton.addEventListener('click', startGame);
    restartButton.addEventListener('click', startGame);
    choices.forEach(function (choice) {
      choice.addEventListener('click', function () { chooseVariant(choice); });
    });
    document.addEventListener('keydown', function (event) {
      if (!state.running || event.altKey || event.ctrlKey || event.metaKey) return;
      var target = event.target;
      if (target && (target.matches('input,textarea,select') || target.isContentEditable)) return;
      var number = Number(event.key);
      if (number >= 1 && number <= choices.length) {
        event.preventDefault();
        chooseVariant(choices[number - 1]);
      }
    });

    function basePageUrl() {
      var canonical = document.querySelector('link[rel="canonical"]');
      var baseUrl = canonical && canonical.href ? canonical.href : window.location.href.split(/[?#]/)[0];
      return baseUrl.replace(/[?#].*$/, '').replace(/\/$/, '');
    }

    function shareUrl() {
      return basePageUrl() + '?view=oatorders&share=v142#oatbedient-orders';
    }

    function resultShareUrl() {
      var resultViews = {
        'Oat Rookie on the Rise': 'oatresult-rookie',
        'Foam Streak Finder': 'oatresult-foam',
        'Oat Route Operator': 'oatresult-operator',
        'Master of the Carton': 'oatresult-master',
        'Café Route Champion': 'oatresult-champion'
      };
      var view = resultViews[resultTitle.textContent] || 'oatresult-rookie';
      return basePageUrl() + '?view=' + encodeURIComponent(view) +
        '&oatbedient-orders=v78#oatbedient-orders';
    }

    function shareText() {
      return 'I earned “' + resultTitle.textContent + '” in Oatbedient Orders with ' + state.score +
        ' points and a Foam Streak of ' + state.bestStreak + '.' +
        (state.arrived ? ' Oatdit reached the café!' : '') +
        ' Can you beat my oat route? #OatbedientOrders #ChefsAndBakersPH';
    }

    function copyShareText() {
      var fullText = shareText() + ' ' + shareUrl();
      if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(fullText);
      return Promise.reject(new Error('Clipboard unavailable'));
    }

    function roundedRect(context, x, y, width, height, radius) {
      var r = Math.min(radius, width / 2, height / 2);
      context.beginPath();
      context.moveTo(x + r, y);
      context.lineTo(x + width - r, y);
      context.quadraticCurveTo(x + width, y, x + width, y + r);
      context.lineTo(x + width, y + height - r);
      context.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
      context.lineTo(x + r, y + height);
      context.quadraticCurveTo(x, y + height, x, y + height - r);
      context.lineTo(x, y + r);
      context.quadraticCurveTo(x, y, x + r, y);
      context.closePath();
    }

    function canvasTextLines(context, text, maxWidth) {
      var words = text.split(' ');
      var lines = [];
      var line = '';
      words.forEach(function (word) {
        var test = line ? line + ' ' + word : word;
        if (line && context.measureText(test).width > maxWidth) {
          lines.push(line);
          line = word;
        } else {
          line = test;
        }
      });
      if (line) lines.push(line);
      return lines;
    }

    function gifPalette() {
      return [
        [53,91,127], [36,63,92], [247,241,229], [255,253,248], [222,149,38], [189,116,16], [51,41,31], [109,98,86],
        [73,169,221], [128,208,191], [158,94,59], [98,198,173], [240,109,139], [238,195,72], [232,230,217], [204,204,196],
        [255,255,255], [28,39,54], [72,106,138], [116,151,181], [244,214,169], [251,225,206], [215,181,145], [164,132,101],
        [42,128,99], [234,247,240], [255,240,234], [165,93,54], [219,230,239], [91,77,64], [243,176,75], [120,199,181]
      ];
    }

    function quantizeGifFrame(imageData, palette) {
      var pixels = imageData.data;
      var output = new Uint8Array(imageData.width * imageData.height);
      var cache = new Int16Array(32768);
      cache.fill(-1);
      for (var pixel = 0, outputIndex = 0; pixel < pixels.length; pixel += 4, outputIndex += 1) {
        var red = pixels[pixel];
        var green = pixels[pixel + 1];
        var blue = pixels[pixel + 2];
        var key = ((red >> 3) << 10) | ((green >> 3) << 5) | (blue >> 3);
        var cached = cache[key];
        if (cached >= 0) {
          output[outputIndex] = cached;
          continue;
        }
        var best = 0;
        var bestDistance = Infinity;
        for (var colorIndex = 0; colorIndex < palette.length; colorIndex += 1) {
          var color = palette[colorIndex];
          var redDifference = red - color[0];
          var greenDifference = green - color[1];
          var blueDifference = blue - color[2];
          var distance = (redDifference * redDifference) + (greenDifference * greenDifference) + (blueDifference * blueDifference);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = colorIndex;
          }
        }
        cache[key] = best;
        output[outputIndex] = best;
      }
      return output;
    }

    function gifLzw(indices, minimumCodeSize) {
      var clearCode = 1 << minimumCodeSize;
      var endCode = clearCode + 1;
      var dictionary;
      var nextCode;
      var codeSize;
      var bytes = [];
      var currentByte = 0;
      var currentBits = 0;

      function resetDictionary() {
        dictionary = new Map();
        nextCode = endCode + 1;
        codeSize = minimumCodeSize + 1;
      }

      function writeCode(code) {
        currentByte |= code << currentBits;
        currentBits += codeSize;
        while (currentBits >= 8) {
          bytes.push(currentByte & 255);
          currentByte >>>= 8;
          currentBits -= 8;
        }
      }

      resetDictionary();
      writeCode(clearCode);
      var prefix = indices[0];
      for (var index = 1; index < indices.length; index += 1) {
        var suffix = indices[index];
        var key = (prefix << 8) | suffix;
        if (dictionary.has(key)) {
          prefix = dictionary.get(key);
          continue;
        }
        writeCode(prefix);
        if (nextCode < 4096) {
          dictionary.set(key, nextCode);
          nextCode += 1;
          if (nextCode === (1 << codeSize) && codeSize < 12) codeSize += 1;
        } else {
          writeCode(clearCode);
          resetDictionary();
        }
        prefix = suffix;
      }
      writeCode(prefix);
      writeCode(endCode);
      if (currentBits > 0) bytes.push(currentByte & 255);
      return bytes;
    }

    function encodeAnimatedGif(width, height, frames, palette, delay) {
      var bytes = [];
      function pushWord(value) { bytes.push(value & 255, (value >> 8) & 255); }
      function pushText(text) {
        for (var i = 0; i < text.length; i += 1) bytes.push(text.charCodeAt(i));
      }
      function pushBlocks(data) {
        for (var offset = 0; offset < data.length; offset += 255) {
          var length = Math.min(255, data.length - offset);
          bytes.push(length);
          for (var i = 0; i < length; i += 1) bytes.push(data[offset + i]);
        }
        bytes.push(0);
      }

      pushText('GIF89a');
      pushWord(width);
      pushWord(height);
      bytes.push(0xf4, 0, 0);
      palette.forEach(function (color) { bytes.push(color[0], color[1], color[2]); });
      bytes.push(0x21, 0xff, 0x0b);
      pushText('NETSCAPE2.0');
      bytes.push(0x03, 0x01, 0x00, 0x00, 0x00);

      frames.forEach(function (frame) {
        bytes.push(0x21, 0xf9, 0x04, 0x04);
        pushWord(delay);
        bytes.push(0x00, 0x00);
        bytes.push(0x2c);
        pushWord(0);
        pushWord(0);
        pushWord(width);
        pushWord(height);
        bytes.push(0x00, 0x05);
        pushBlocks(gifLzw(frame, 5));
      });
      bytes.push(0x3b);
      return new Blob([new Uint8Array(bytes)], { type: 'image/gif' });
    }

    function createFacebookGif() {
      return new Promise(function (resolve, reject) {
        var canvas = document.createElement('canvas');
        canvas.width = 432;
        canvas.height = 540;
        var context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) { reject(new Error('Canvas unavailable')); return; }
        var palette = gifPalette();
        var frames = [];
        var frameCount = 8;

        function drawFrame(frameIndex) {
          var phase = (frameIndex / frameCount) * Math.PI * 2;
          context.fillStyle = '#355b7f';
          context.fillRect(0, 0, canvas.width, canvas.height);
          context.save();
          context.translate(8, 5);
          context.rotate(-0.012);
          context.fillStyle = '#de9526';
          roundedRect(context, 28, 22, 382, 498, 25);
          context.fill();
          context.restore();
          context.fillStyle = '#f7f1e5';
          roundedRect(context, 18, 16, 382, 498, 25);
          context.fill();

          context.textAlign = 'center';
          context.fillStyle = '#bd7410';
          context.font = '800 12px Arial, sans-serif';
          context.fillText('OATBEDIENT ORDERS', 209, 43);
          context.fillStyle = '#355b7f';
          context.fillRect(163, 53, 92, 3);

          var confettiColors = ['#de9526', '#49a9dd', '#80d0bf', '#f06d8b'];
          for (var piece = 0; piece < 10; piece += 1) {
            var x = 55 + ((piece * 37 + frameIndex * 13) % 325);
            var y = 72 + ((piece * 29 + frameIndex * 17) % 125);
            context.save();
            context.translate(x, y);
            context.rotate((piece + frameIndex) * .35);
            context.fillStyle = confettiColors[piece % confettiColors.length];
            context.fillRect(-3, -6, 6, 12);
            context.restore();
          }

          if (resultMascot && resultMascot.complete && resultMascot.naturalWidth) {
            var bounce = Math.sin(phase) * 7;
            try { context.drawImage(resultMascot, 156, 64 + bounce, 108, 108); } catch (error) {}
          }

          context.fillStyle = '#de9526';
          roundedRect(context, 130, 170, 166, 25, 8);
          context.fill();
          context.fillStyle = '#33291f';
          context.font = '900 9px Arial, sans-serif';
          context.fillText(state.arrived ? 'OATDIT MADE IT TO THE CAFÉ!' : 'MY OAT ROUTE RESULT', 213, 187);

          context.fillStyle = '#33291f';
          context.font = '900 28px Arial, sans-serif';
          var titleLines = canvasTextLines(context, resultTitle.textContent, 350);
          titleLines.slice(0, 2).forEach(function (line, lineIndex) {
            context.fillText(line, 209, 229 + (lineIndex * 31));
          });

          context.fillStyle = '#355b7f';
          roundedRect(context, 55, 278, 322, 80, 15);
          context.fill();
          context.fillStyle = '#ffffff';
          context.font = '900 31px Arial, sans-serif';
          context.fillText(String(state.score), 143, 319);
          context.fillText('×' + String(state.bestStreak), 295, 319);
          context.fillStyle = '#f7f1e5';
          context.font = '700 10px Arial, sans-serif';
          context.fillText('POINTS', 143, 340);
          context.fillText('FOAM STREAK', 295, 340);

          context.save();
          context.strokeStyle = '#355b7f';
          context.lineWidth = 3;
          context.setLineDash([8, 7]);
          context.beginPath();
          context.moveTo(70, 391);
          context.lineTo(354, 391);
          context.stroke();
          context.restore();
          ['#49a9dd', '#80d0bf', '#9e5e3b', '#62c6ad'].forEach(function (color, index) {
            var progress = Math.min(1, Math.max(0, (frameIndex - index + 2) / 5));
            var cartonX = 82 + (index * 73);
            var cartonY = 391 - (Math.sin((phase + index) * 1.2) * 4 * progress);
            context.fillStyle = color;
            context.strokeStyle = '#355b7f';
            context.lineWidth = 2;
            roundedRect(context, cartonX - 10, cartonY - 15, 20, 30, 4);
            context.fill();
            context.stroke();
          });
          context.fillStyle = '#bd7410';
          context.font = '900 10px Arial, sans-serif';
          context.fillText('CAFÉ!', 380, 395);

          context.save();
          context.translate(0, Math.sin(phase) * 2);
          context.fillStyle = '#de9526';
          roundedRect(context, 65, 426, 302, 58, 14);
          context.fill();
          context.restore();
          context.fillStyle = '#33291f';
          context.font = '900 15px Arial, sans-serif';
          context.fillText('CAN YOU BEAT MY OAT ROUTE?', 216, 452);
          context.font = '800 10px Arial, sans-serif';
          context.fillText('PLAY OATBEDIENT ORDERS', 216, 470);
          context.fillStyle = '#6d6256';
          context.font = '700 9px Arial, sans-serif';
          context.fillText('chefsandbakersph.com/pages/oatbedient', 216, 504);

          frames.push(quantizeGifFrame(context.getImageData(0, 0, canvas.width, canvas.height), palette));
          if (frameIndex + 1 < frameCount) {
            setTimeout(function () { drawFrame(frameIndex + 1); }, 0);
          } else {
            try { resolve(encodeAnimatedGif(canvas.width, canvas.height, frames, palette, 12)); }
            catch (error) { reject(error); }
          }
        }
        drawFrame(0);
      });
    }

    function createResultCard() {
      return new Promise(function (resolve, reject) {
        var canvas = document.createElement('canvas');
        canvas.width = 1080;
        canvas.height = 1350;
        var context = canvas.getContext('2d');
        if (!context) { reject(new Error('Canvas unavailable')); return; }

        context.fillStyle = '#355b7f';
        context.fillRect(0, 0, canvas.width, canvas.height);

        context.save();
        context.translate(24, 20);
        context.rotate(-0.012);
        context.fillStyle = '#de9526';
        roundedRect(context, 66, 65, 930, 1195, 58);
        context.fill();
        context.restore();

        context.save();
        context.shadowColor = 'rgba(28,39,54,.25)';
        context.shadowBlur = 30;
        context.shadowOffsetY = 18;
        context.fillStyle = '#f7f1e5';
        roundedRect(context, 45, 45, 930, 1195, 58);
        context.fill();
        context.restore();

        context.fillStyle = '#bd7410';
        context.font = '800 24px Arial, sans-serif';
        context.textAlign = 'center';
        context.fillText('DELIVERY COMPLETE', 510, 112);
        context.fillStyle = '#33291f';
        context.font = '900 38px Arial, sans-serif';
        context.fillText('OATBEDIENT ORDERS', 510, 160);
        context.fillStyle = '#355b7f';
        context.fillRect(390, 181, 240, 7);

        function finishCard() {
          var confettiColors = ['#de9526', '#49a9dd', '#80d0bf', '#9e5e3b', '#f06d8b'];
          [
            [185, 250, -8], [235, 315, 11], [825, 255, 8], [790, 340, -10],
            [160, 420, 7], [850, 430, 12], [225, 500, -12], [805, 510, 6]
          ].forEach(function (piece, index) {
            context.save();
            context.translate(piece[0], piece[1]);
            context.rotate(piece[2] * Math.PI / 180);
            context.fillStyle = confettiColors[index % confettiColors.length];
            roundedRect(context, -8, -18, 16, 36, 5);
            context.fill();
            context.restore();
          });
          if (state.arrived) {
            context.save();
            [[285, 250, '#de9526', 18], [735, 245, '#de9526', 18],
              [245, 405, '#de9526', 18], [775, 420, '#de9526', 18],
              [330, 330, '#49a9dd', 13], [700, 345, '#49a9dd', 13],
              [315, 490, '#49a9dd', 13], [720, 500, '#49a9dd', 13]
            ].forEach(function (spark) {
              context.strokeStyle = spark[2];
              context.lineWidth = 7;
              context.beginPath();
              context.moveTo(spark[0] - spark[3], spark[1]);
              context.lineTo(spark[0] + spark[3], spark[1]);
              context.moveTo(spark[0], spark[1] - spark[3]);
              context.lineTo(spark[0], spark[1] + spark[3]);
              context.stroke();
            });
            context.restore();
          }

          context.save();
          context.translate(0, 2);
          context.rotate(-0.008);
          context.fillStyle = '#de9526';
          roundedRect(context, 330, 548, 360, 54, 18);
          context.fill();
          context.restore();
          context.fillStyle = '#33291f';
          context.font = '900 20px Arial, sans-serif';
          context.fillText(state.arrived ? 'OATDIT MADE IT TO THE CAFÉ!' : 'MY OAT ROUTE RESULT', 510, 583);

          context.fillStyle = '#33291f';
          context.font = '900 68px Arial, sans-serif';
          var titleLines = canvasTextLines(context, resultTitle.textContent, 800);
          titleLines.slice(0, 2).forEach(function (line, index) {
            context.fillText(line, 510, 665 + (index * 76));
          });

          context.save();
          context.strokeStyle = '#355b7f';
          context.lineWidth = 7;
          context.setLineDash([18, 15]);
          context.beginPath();
          context.moveTo(230, 778);
          context.lineTo(790, 778);
          context.stroke();
          context.restore();
          var resultCartons = [
            ['#49a9dd', 'BARISTA'],
            ['#80d0bf', 'ARTISAN'],
            ['#9e5e3b', 'CHOCOLATE'],
            ['#62c6ad', 'ZERO']
          ];
          resultCartons.forEach(function (carton, index) {
            var color = carton[0];
            var label = carton[1];
            var x = 270 + (index * 160);
            context.save();
            context.translate(x, 778);
            context.rotate((index % 2 ? 3 : -3) * Math.PI / 180);
            context.fillStyle = color;
            context.strokeStyle = '#355b7f';
            context.lineWidth = 5;
            roundedRect(context, -27, -34, 54, 68, 8);
            context.fill();
            context.stroke();
            context.beginPath();
            context.moveTo(-24, -34);
            context.lineTo(-15, -47);
            context.lineTo(15, -47);
            context.lineTo(24, -34);
            context.closePath();
            context.fillStyle = color;
            context.fill();
            context.stroke();
            context.fillStyle = '#ffffff';
            context.strokeStyle = '#355b7f';
            context.lineWidth = 3;
            roundedRect(context, 5, -53, 14, 8, 3);
            context.fill();
            context.stroke();
            context.strokeStyle = '#ffffff';
            context.lineWidth = 4;
            if (index === 0) {
              roundedRect(context, -12, -4, 21, 16, 4);
              context.stroke();
              context.beginPath();
              context.arc(-2, -8, 9, Math.PI, Math.PI * 2);
              context.stroke();
            } else if (index === 1) {
              context.beginPath();
              context.arc(0, -3, 14, .2, Math.PI - .2);
              context.stroke();
              context.beginPath();
              context.arc(0, 5, 14, Math.PI + .2, (Math.PI * 2) - .2);
              context.stroke();
            } else if (index === 2) {
              context.beginPath();
              context.ellipse(0, 1, 10, 15, 0, 0, Math.PI * 2);
              context.stroke();
              context.beginPath();
              context.arc(-1, 1, 8, Math.PI / 2, Math.PI * 1.5);
              context.stroke();
            } else {
              context.beginPath();
              context.moveTo(0, -16);
              context.lineTo(0, 16);
              context.moveTo(-15, 0);
              context.lineTo(15, 0);
              context.moveTo(-10, -10);
              context.lineTo(10, 10);
              context.moveTo(-10, 10);
              context.lineTo(10, -10);
              context.stroke();
            }
            context.restore();
            context.fillStyle = '#355b7f';
            context.font = '800 15px Arial, sans-serif';
            context.fillText(label, x, 834);
          });
          context.fillStyle = '#bd7410';
          context.font = '900 22px Arial, sans-serif';
          context.fillText('CAFÉ!', 850, 786);

          context.save();
          context.shadowColor = 'rgba(51,41,31,.24)';
          context.shadowBlur = 0;
          context.shadowOffsetX = 10;
          context.shadowOffsetY = 12;
          context.fillStyle = '#355b7f';
          roundedRect(context, 145, 850, 790, 155, 32);
          context.fill();
          context.restore();

          context.fillStyle = '#ffffff';
          context.font = '900 68px Arial, sans-serif';
          context.fillText(String(state.score), 360, 930);
          context.fillText('×' + String(state.bestStreak), 730, 930);
          context.fillStyle = '#f7f1e5';
          context.font = '700 24px Arial, sans-serif';
          context.fillText('POINTS', 360, 978);
          context.fillText('FOAM STREAK', 730, 978);

          context.save();
          context.translate(0, 3);
          context.rotate(-0.009);
          context.fillStyle = '#de9526';
          roundedRect(context, 180, 1040, 660, 105, 26);
          context.fill();
          context.restore();
          context.fillStyle = '#33291f';
          context.font = '900 31px Arial, sans-serif';
          context.fillText('CAN YOU BEAT MY OAT ROUTE?', 510, 1085);
          context.font = '800 21px Arial, sans-serif';
          context.fillText('PLAY OATBEDIENT ORDERS', 510, 1122);

          context.fillStyle = '#bd7410';
          context.font = '800 22px Arial, sans-serif';
          context.fillText('CHEFS & BAKERS PH  •  OATBEDIENT', 510, 1196);
          context.fillStyle = '#6d6256';
          context.font = '600 20px Arial, sans-serif';
          context.fillText(shareUrl().replace(/^https?:\/\//, '').split('?')[0].replace(/\/$/, ''), 510, 1234);

          canvas.toBlob(function (blob) {
            if (blob) resolve(blob);
            else reject(new Error('Could not create result card'));
          }, 'image/jpeg', .92);
        }

        if (resultMascot && resultMascot.complete && resultMascot.naturalWidth) {
          try {
            context.drawImage(resultMascot, 330, 185, 360, 360);
          } catch (error) {}
          finishCard();
        } else if (resultMascot) {
          var cardMascot = new Image();
          cardMascot.crossOrigin = 'anonymous';
          cardMascot.onload = function () {
            try { context.drawImage(cardMascot, 330, 185, 360, 360); } catch (error) {}
            finishCard();
          };
          cardMascot.onerror = finishCard;
          cardMascot.src = resultMascot.currentSrc || resultMascot.src;
        } else {
          finishCard();
        }
      });
    }

    if (facebookShareButton) {
      facebookShareButton.addEventListener('click', function () {
        var isMobileFacebook = window.matchMedia('(pointer:coarse)').matches ||
          /iPhone|iPad|iPod|Android/i.test(navigator.userAgent || '');
        if (!isMobileFacebook) {
          var desktopFacebookUrl = 'https://www.facebook.com/sharer/sharer.php?u=' +
            encodeURIComponent(resultShareUrl()) +
            '&quote=' + encodeURIComponent(shareText() + ' ' + shareUrl()) +
            '&hashtag=' + encodeURIComponent('#OatbedientOrders');
          copyShareText().then(function () {
            shareStatus.textContent = 'Score caption copied. The result card now opens the game when clicked!';
          }).catch(function () {
            shareStatus.textContent = 'Your animated result card now opens the game when clicked!';
          });
          window.open(desktopFacebookUrl, 'oatbedient-facebook', 'width=700,height=680,resizable=yes,scrollbars=yes');
          return;
        }

        facebookShareButton.disabled = true;
        shareStatus.textContent = 'Preparing your personalised mobile result card…';
        createResultCard().then(function (blob) {
          var file = new File([blob], 'oatbedient-orders-' + state.score + '.jpg', { type: 'image/jpeg' });
          var canShareResult = false;
          if (navigator.share && navigator.canShare) {
            try { canShareResult = navigator.canShare({ files: [file] }); }
            catch (error) {}
          }

          if (canShareResult) {
            return navigator.share({
              files: [file],
              title: 'My Oatbedient Orders result',
              text: shareText() + ' Play here: ' + resultShareUrl()
            }).then(function () {
              shareStatus.textContent = 'Your earned-result card is ready, with a tappable game link!';
            });
          }

          var downloadUrl = URL.createObjectURL(blob);
          var download = document.createElement('a');
          download.href = downloadUrl;
          download.download = file.name;
          document.body.appendChild(download);
          download.click();
          download.remove();
          setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 1000);
          return copyShareText().then(function () {
            shareStatus.textContent = 'Result card saved and caption copied. Add both to your Facebook post!';
          });
        }).catch(function (error) {
          if (error && error.name === 'AbortError') return;
          return copyShareText().then(function () {
            shareStatus.textContent = 'Your score caption is copied. Add it with your result screenshot on Facebook!';
          }).catch(function () {
            shareStatus.textContent = shareText();
          });
        }).finally(function () {
          facebookShareButton.disabled = false;
        });
      });
    }

    if (instagramShareButton) {
      instagramShareButton.addEventListener('click', function () {
        instagramShareButton.disabled = true;
        shareStatus.textContent = 'Preparing your Oatbedient result card…';
        createResultCard().then(function (blob) {
          var file = new File([blob], 'oatbedient-orders-' + state.score + '.jpg', { type: 'image/jpeg' });
          var shareData = {
            files: [file],
            title: 'Oatbedient Orders',
            text: shareText() + ' Play here: ' + shareUrl()
          };
          if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
            return navigator.share(shareData).then(function () {
              shareStatus.textContent = 'Your story-ready result card is on its way!';
            });
          }

          var downloadUrl = URL.createObjectURL(blob);
          var download = document.createElement('a');
          download.href = downloadUrl;
          download.download = file.name;
          document.body.appendChild(download);
          download.click();
          download.remove();
          setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 1000);
          return copyShareText().then(function () {
            shareStatus.textContent = 'Result card downloaded and caption copied. Add both to Instagram!';
          }).catch(function () {
            shareStatus.textContent = 'Result card downloaded. Add it to your Instagram Story or post!';
          });
        }).catch(function () {
          return copyShareText().then(function () {
            shareStatus.textContent = 'Caption copied. Paste it into Instagram with your favourite screenshot!';
          }).catch(function () {
            shareStatus.textContent = shareText();
          });
        }).finally(function () {
          instagramShareButton.disabled = false;
        });
      });
    }
  });
})();

// Immersive, performance-safe brand layer. Fine-pointer devices receive
// gentle photo depth, tactile card light, and paper-stamp button feedback.
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  document.documentElement.classList.add('cb-immersive');

  var sections = Array.from(document.querySelectorAll('.cb-block'));
  if ('IntersectionObserver' in window) {
    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('cb-section-live');
      });
    }, { rootMargin: '-12% 0px -18%', threshold: 0.08 });
    sections.forEach(function (section) { sectionObserver.observe(section); });
  } else {
    sections.forEach(function (section) { section.classList.add('cb-section-live'); });
  }

  document.querySelectorAll('.cb-btn, .cb-header-cta').forEach(function (button) {
    button.addEventListener('pointerdown', function (event) {
      var rect = button.getBoundingClientRect();
      button.style.setProperty('--cb-tap-x', (event.clientX - rect.left) + 'px');
      button.style.setProperty('--cb-tap-y', (event.clientY - rect.top) + 'px');
      button.classList.remove('cb-is-pressed');
      void button.offsetWidth;
      button.classList.add('cb-is-pressed');
    });
    button.addEventListener('animationend', function () {
      button.classList.remove('cb-is-pressed');
    });
  });

  if (!finePointer || reduce) return;

  var depthTargets = Array.from(document.querySelectorAll('.cb-hero__art, .cb-feature__photo, .cb-story .cb-cm'));
  var lightTargets = Array.from(document.querySelectorAll('.cb-cat, .cb-prod, .cb-loc, .cb-pillar, .cb-testimonial, .card-wrapper'));

  function bindPointerSurface(element, depth) {
    var frame = 0;
    element.classList.add(depth ? 'cb-depth-surface' : 'cb-light-surface');
    if (!depth && !element.querySelector(':scope > .cb-surface-light')) {
      var light = document.createElement('span');
      light.className = 'cb-surface-light';
      light.setAttribute('aria-hidden', 'true');
      element.appendChild(light);
    }

    element.addEventListener('pointermove', function (event) {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        var rect = element.getBoundingClientRect();
        var x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
        var y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
        element.style.setProperty('--cb-local-x', (x * 100).toFixed(2) + '%');
        element.style.setProperty('--cb-local-y', (y * 100).toFixed(2) + '%');
        if (depth) {
          element.style.setProperty('--cb-shift-x', ((x - 0.5) * 9).toFixed(2) + 'px');
          element.style.setProperty('--cb-shift-y', ((y - 0.5) * 7).toFixed(2) + 'px');
        }
      });
    });

    element.addEventListener('pointerleave', function () {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      element.style.removeProperty('--cb-local-x');
      element.style.removeProperty('--cb-local-y');
      element.style.removeProperty('--cb-shift-x');
      element.style.removeProperty('--cb-shift-y');
    });
  }

  depthTargets.forEach(function (element) { bindPointerSurface(element, true); });
  lightTargets.forEach(function (element) { bindPointerSurface(element, false); });
})();

// Business benefits reveal one useful detail on click or keyboard activation.
(function () {
  document.querySelectorAll('[data-business-benefit]').forEach(function (button) {
    button.addEventListener('click', function () {
      var item = button.closest('.cb-business-benefit');
      var open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();

// Keep the footer's Shopify-safe single link while choosing the best
// Messenger destination for each screen size.
(function () {
  var desktopMessenger = 'https://www.facebook.com/messages/t/209430259154174';
  var mobileMessenger = 'https://m.me/chefsandbakers';
  var media = window.matchMedia('(max-width: 989px)');

  function updateFooterMessenger() {
    document.querySelectorAll('.footer a[href*="facebook.com/messages/t/209430259154174"], .footer a[href*="m.me/chefsandbakers"]').forEach(function (link) {
      if (link.textContent.trim().toLowerCase() === 'messenger') {
        link.href = media.matches ? mobileMessenger : desktopMessenger;
      }
    });
  }

  updateFooterMessenger();
  if (media.addEventListener) media.addEventListener('change', updateFooterMessenger);
  else if (media.addListener) media.addListener(updateFooterMessenger);
})();

// Show three different, verified five-star Google reviews on each fresh visit.
(function () {
  var cards = Array.from(document.querySelectorAll('[data-google-testimonial]'));
  if (!cards.length) return;

  var reviews = [
    { name: 'Leonilyn Manguilimotan', meta: 'Google review', quote: 'The staff are very friendly. The owners are nice. And the product selection is updated weekly. I am a happy suki.' },
    { name: 'Labelle Letour', meta: 'Google review', quote: 'Staff are kind and they know the products. Items are always brand new and their cake decorating product selection can\'t be beat!' },
    { name: 'Louie', meta: 'Google review · Local Guide', quote: 'A large selection of fine ingredients and top notch kitchen equipment.' },
    { name: 'Christine Joy Suarnaba', meta: 'Google review', quote: 'All in 1 shop for my baking necessities.' },
    { name: 'Marga', meta: 'Google review', quote: 'Very nice, good place to go when looking for baking stuff and ingredients.' },
    { name: 'Jimmy Mirasol Fernandez', meta: 'Google review', quote: 'My happy place for everything baking and cake decorating.' },
    { name: 'R H E A P O', meta: 'Google review · Local Guide', quote: 'A baker’s “heaven” in every bakers ❤️. A lot of things and ingredients you can find inside the store.' },
    { name: 'Chef Kris Klein', meta: 'Google review · Local Guide', quote: 'Very friendly and accommodating staff. They have a complete variety of everything I need for baking.' },
    { name: 'Eden Eriman', meta: 'Google review · Local Guide', quote: 'Very orderly. Staff are good, hardworking, and accommodating. Always new things to discover.' },
    { name: 'Prashanna', meta: 'Google review', quote: 'A must visit when you’re in Bacolod. Staff are friendly and knowledgeable.' },
    { name: 'Richard Chiu', meta: 'Google review · Local Guide', quote: 'One of my go-to suppliers for baking, cooking, and pastry ingredients. Very helpful staff.' },
    { name: 'Diwani Duropan', meta: 'Google review', quote: 'Very clean and organized. Staff are helpful.' },
    { name: 'Menchie Castillo', meta: 'Google review', quote: 'Very convenient and good service.' },
    { name: 'Jophil Abalayan', meta: 'Google review', quote: 'We always get what we need.' }
  ];

  for (var i = reviews.length - 1; i > 0; i -= 1) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = reviews[i]; reviews[i] = reviews[j]; reviews[j] = temp;
  }

  var chosen = reviews.slice(0, cards.length);
  var signature = chosen.map(function (review) { return review.name; }).sort().join('|');
  try {
    var previous = sessionStorage.getItem('cb-google-review-set');
    if (signature === previous) {
      chosen = reviews.slice(1, cards.length + 1);
      signature = chosen.map(function (review) { return review.name; }).sort().join('|');
    }
    sessionStorage.setItem('cb-google-review-set', signature);
  } catch (error) {}

  cards.forEach(function (card, index) {
    var review = chosen[index];
    if (!review) return;
    var quote = card.querySelector('[data-review-quote]');
    var name = card.querySelector('[data-review-name]');
    var meta = card.querySelector('[data-review-meta]');
    if (quote) quote.textContent = '“' + review.quote + '”';
    if (name) name.textContent = review.name;
    if (meta) meta.textContent = review.meta;
  });
})();

// Hero headline: words rise in one by one, then the marker stroke
// underlines the final word once they have settled.
(function () {
  var h = document.querySelector('.cb-hero .cb-h1');
  if (!h || h.querySelector('.cb-word') || h.querySelector('.cb-uline')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var words = h.textContent.trim().split(/\s+/);
  if (!words.length) return;
  h.textContent = '';
  words.forEach(function (w, i) {
    var s = document.createElement('span');
    s.className = 'cb-word';
    if (i === words.length - 1 && words.length > 1) {
      var u = document.createElement('span');
      u.className = 'cb-uline';
      u.textContent = w;
      s.appendChild(u);
    } else {
      s.textContent = w;
    }
    if (!reduce) s.style.setProperty('--wd', (0.1 + i * 0.08) + 's');
    h.appendChild(s);
    if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
  });
  if (!reduce) h.style.setProperty('--uld', (0.1 + words.length * 0.08 + 0.35) + 's');
  requestAnimationFrame(function () {
    requestAnimationFrame(function () { h.classList.add('cb-h1--in'); });
  });
})();

// Hero slideshow: gentle crossfade every few seconds
(function () {
  document.querySelectorAll('.cb-slides').forEach(function (w) {
    var slides = w.querySelectorAll('.cb-slide');
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 4600);
  });
})();

// Oatbedient locator: switch between our branches and the growing partner network.
(function () {
  // Oatdit's sailing kit. Everything is synthesized on the fly, so there is nothing
  // extra to download: a breath of wind as the bangka leaves, then a warm little
  // mallet figure as it ties up at the next pin. Tap pins in a row and the figure
  // climbs the pentatonic ladder, the way a run of pickups rewards you in a platformer.
  var SailSound = (function () {
    var context = null;
    var master = null;
    var enabled = true;
    var ladder = [0, 2, 4, 7, 9, 12];
    var step = 0;
    var stepTimer = null;
    var mediaAudio = {};
    var Engine = window.AudioContext || window.webkitAudioContext;

    try { enabled = localStorage.getItem('cb-oat-map-sound') !== 'off'; } catch (error) {}

    function ready() {
      if (!Engine || !enabled) return null;
      if (!context) {
        context = new Engine();
        master = context.createGain();
        master.gain.value = .9;
        master.connect(context.destination);
      }
      return context;
    }

    function configure(root) {
      if (typeof Audio === 'undefined' || !root) return;
      var useSoftMedia = window.matchMedia('(max-width: 990px), (pointer: coarse)').matches;
      if (!useSoftMedia) return;
      ['sail'].forEach(function (name) {
        var source = root.getAttribute('data-oat-locator-audio-' + name);
        if (!source) return;
        var audio = new Audio(source);
        audio.preload = 'auto';
        audio.playsInline = true;
        audio.volume = .76;
        audio.load();
        mediaAudio[name] = audio;
      });
    }

    function playMedia(name) {
      var audio = mediaAudio[name];
      if (!enabled || !audio || document.hidden) return false;
      try {
        audio.pause();
        audio.currentTime = 0;
        var playback = audio.play();
        if (playback && typeof playback.catch === 'function') {
          playback.catch(function () {});
        }
        return true;
      } catch (error) {
        return false;
      }
    }

    // iOS and iPadOS will report that sound is enabled while keeping Web Audio
    // suspended until it is explicitly unlocked inside a real user gesture.
    // Starting a silent one-sample buffer is the most reliable Safari unlock.
    function unlock() {
      if (mediaAudio.sail || mediaAudio.arrival) return Promise.resolve(true);
      var current = ready();
      if (!current) return Promise.resolve(null);
      try {
        var buffer = current.createBuffer(1, 1, 22050);
        var source = current.createBufferSource();
        source.buffer = buffer;
        source.connect(master);
        source.start(0);
      } catch (error) {}
      if (current.state === 'running') return Promise.resolve(current);
      return current.resume().then(function () {
        return current.state === 'running' ? current : null;
      }).catch(function () {
        return null;
      });
    }

    function playWhenReady(callback) {
      var current = ready();
      if (!current || document.hidden) return;
      if (current.state === 'running') {
        callback();
        return;
      }
      unlock().then(function (unlocked) {
        if (unlocked && !document.hidden) callback();
      });
    }

    function tone(freq, at, dur, vol, type) {
      var osc = context.createOscillator();
      var gain = context.createGain();
      osc.type = type || 'sine';
      osc.frequency.setValueAtTime(freq, at);
      gain.gain.setValueAtTime(.0001, at);
      gain.gain.exponentialRampToValueAtTime(vol, at + .012);
      gain.gain.exponentialRampToValueAtTime(.0001, at + dur);
      osc.connect(gain);
      gain.connect(master);
      osc.start(at);
      osc.stop(at + dur + .04);
    }

    // A marimba-ish voice: fundamental, an octave of shimmer, a touch of woody top.
    function mallet(freq, at, dur, vol) {
      tone(freq, at, dur, vol, 'sine');
      tone(freq * 2, at, dur * .44, vol * .3, 'sine');
      tone(freq * 3.01, at, dur * .18, vol * .11, 'triangle');
    }

    function breeze(at, dur) {
      var frames = Math.max(1, Math.ceil(context.sampleRate * dur));
      var buffer = context.createBuffer(1, frames, context.sampleRate);
      var data = buffer.getChannelData(0);
      for (var i = 0; i < frames; i += 1) data[i] = (Math.random() * 2 - 1) * .55;
      var source = context.createBufferSource();
      source.buffer = buffer;
      var band = context.createBiquadFilter();
      band.type = 'bandpass';
      band.Q.value = .85;
      band.frequency.setValueAtTime(360, at);
      band.frequency.exponentialRampToValueAtTime(1480, at + dur * .58);
      band.frequency.exponentialRampToValueAtTime(560, at + dur);
      var gain = context.createGain();
      gain.gain.setValueAtTime(.0001, at);
      gain.gain.linearRampToValueAtTime(.05, at + dur * .3);
      gain.gain.exponentialRampToValueAtTime(.0001, at + dur);
      source.connect(band);
      band.connect(gain);
      gain.connect(master);
      source.start(at);
      source.stop(at + dur + .03);
    }

    function bumpStep() {
      step = Math.min(step + 1, ladder.length - 1);
      clearTimeout(stepTimer);
      stepTimer = setTimeout(function () { step = 0; }, 2600);
    }

    return {
      configure: configure,
      available: function () { return !!Engine || !!mediaAudio.sail || !!mediaAudio.arrival; },
      enabled: function () { return enabled; },
      running: function () {
        return !!mediaAudio.sail || !!mediaAudio.arrival || (!!context && context.state === 'running');
      },
      unlock: unlock,
      set: function (value) {
        enabled = !!value;
        try { localStorage.setItem('cb-oat-map-sound', enabled ? 'on' : 'off'); } catch (error) {}
        if (!enabled) {
          step = 0;
          clearTimeout(stepTimer);
          Object.keys(mediaAudio).forEach(function (name) {
            mediaAudio[name].pause();
            mediaAudio[name].currentTime = 0;
          });
        }
      },
      // Desktop: wind plus an arrival chime. Mobile and tablet: departure breeze only.
      // still: the pin was already under Oatdit, so just a friendly tap.
      sail: function (travelling, delay) {
        if (mediaAudio.sail) {
          if (!travelling) return;
          playMedia('sail');
          return;
        }
        playWhenReady(function () {
          var now = context.currentTime + .01;
          if (!travelling) {
            mallet(587.33, now, .34, .055);
            return;
          }
          bumpStep();
          var root = 293.66 * Math.pow(2, ladder[step] / 12);
          var land = now + Math.max(.04, (delay || 0) / 1000);
          breeze(now, Math.max(.16, (delay || 0) / 1000 + .1));
          mallet(root * .5, now + .02, .3, .045);
          mallet(root, land, .52, .085);
          mallet(root * 1.2599, land + .072, .5, .072);
          mallet(root * 1.4983, land + .144, .66, .086);
          tone(root * 4, land + .2, .5, .02, 'sine');
        });
      },
      chirp: function () {
        if (mediaAudio.sail) {
          playMedia('sail');
          return;
        }
        playWhenReady(function () {
          var now = context.currentTime + .01;
          mallet(523.25, now, .34, .07);
          mallet(783.99, now + .075, .42, .06);
        });
      }
    };
  })();

  document.querySelectorAll('[data-oat-locator]').forEach(function (locator) {
    var modes = Array.from(locator.querySelectorAll('[data-oat-locator-mode]'));
    var panes = Array.from(locator.querySelectorAll('[data-oat-locator-pane]'));
    var filters = Array.from(locator.querySelectorAll('[data-oat-region-filter]'));
    var pins = Array.from(locator.querySelectorAll('[data-oat-region-pin]'));
    var branches = Array.from(locator.querySelectorAll('[data-oat-branch]'));
    var summary = locator.querySelector('[data-oat-locator-summary]');
    var partnerFilters = Array.from(locator.querySelectorAll('[data-oat-partner-filter]'));
    var partnerPins = Array.from(locator.querySelectorAll('[data-oat-partner-pin]'));
    var partners = Array.from(locator.querySelectorAll('[data-oat-partner]'));
    var partnerSummary = locator.querySelector('[data-oat-partner-summary]');
    var rider = locator.querySelector('[data-oat-locator-rider]');
    var soundButton = locator.querySelector('[data-oat-locator-sound]');
    var soundLabel = locator.querySelector('[data-oat-locator-sound-label]');
    var listening = false;
    var landTimer;
    SailSound.configure(locator);
    if (!filters.length || !branches.length || !summary) return;

    var regionCopy = {
      all: { count: 11, noun: 'oat stops', place: 'at Chefs & Bakers' },
      negros: { count: 6, noun: 'oat stops', place: 'in Negros Occidental' },
      panay: { count: 3, noun: 'oat stops', place: 'on Panay Island' },
      dumaguete: { count: 1, noun: 'oat stop', place: 'in Dumaguete City' },
      cebu: { count: 1, noun: 'oat stop', place: 'in Cebu City' }
    };
    var partnerCopy = {
      all: { count: 23, noun: 'partner stockists', place: 'grouped by island, then A–Z' },
      luzon: { count: 12, noun: 'partner stockists', place: 'serving Luzon' },
      visayas: { count: 1, noun: 'partner stockist', place: 'serving the Visayas' },
      mindanao: { count: 12, noun: 'partner stockists', place: 'serving Mindanao' }
    };
    var partnerPlaceCopy = {
      isabela: 'Santiago City, Isabela',
      pampanga: 'Pampanga',
      'metro-manila': 'Metro Manila',
      cavite: 'Cavite',
      laguna: 'Laguna',
      albay: 'Legazpi, Albay',
      cebu: 'Cebu City',
      zamboanga: 'Zamboanga City',
      misamis: 'Misamis Occidental',
      cdo: 'Cagayan de Oro',
      cotabato: 'Cotabato City',
      tagum: 'Tagum City',
      davao: 'Davao City'
    };
    var riderTimer;

    // Prime Web Audio before the later click handler moves Oatdit. Pointerdown
    // covers modern touch browsers; touchstart is retained for older iOS Safari.
    var primeSailAudio = function (event) {
      if (soundButton && event && soundButton.contains(event.target)) return;
      if (SailSound.enabled()) SailSound.unlock();
    };
    locator.addEventListener('pointerdown', primeSailAudio, { capture: true, passive: true });
    locator.addEventListener('touchstart', primeSailAudio, { capture: true, passive: true });
    locator.addEventListener('keydown', primeSailAudio, true);

    // The map keeps Philippine time no matter where the visitor is, so a
    // customer in Dubai or Toronto sees the sky as it is back home.
    var mapCard = locator.querySelector('.oat-locator__map-card');
    if (mapCard) {
      var manilaHour = function () {
        try {
          return Number(new Intl.DateTimeFormat('en-PH', {
            timeZone: 'Asia/Manila', hour: 'numeric', hour12: false
          }).format(new Date()));
        } catch (error) {
          // Manila keeps UTC+8 year round, with no daylight saving to track.
          return (new Date().getUTCHours() + 8) % 24;
        }
      };
      var dayparts = [
        { key: 'dawn', from: 4, to: 6, label: 'First light · 4–6 AM' },
        { key: 'morning', from: 6, to: 11, label: 'Morning glow · 6–11 AM' },
        { key: 'midday', from: 11, to: 15, label: 'Sun high · 11 AM–3 PM' },
        { key: 'afternoon', from: 15, to: 17, label: 'Slow afternoon · 3–5 PM' },
        { key: 'golden', from: 17, to: 19, label: 'Golden hour · 5–7 PM' },
        { key: 'dusk', from: 19, to: 21, label: 'Blue hour · 7–9 PM' }
      ];
      var applyDaypart = function () {
        var hour = manilaHour();
        var match = null;
        for (var i = 0; i < dayparts.length; i++) {
          if (hour >= dayparts[i].from && hour < dayparts[i].to) { match = dayparts[i]; break; }
        }
        if (!match) match = { key: 'night', label: 'Stars above the islands · 9 PM–4 AM' };
        if (mapCard.getAttribute('data-oat-daypart') !== match.key) {
          mapCard.setAttribute('data-oat-daypart', match.key);
          var caption = mapCard.querySelector('[data-oat-daypart-label]');
          if (caption) caption.textContent = match.label;
        }
      };
      applyDaypart();
      // Checked every few minutes so a page left open rolls into the next
      // part of the day on its own.
      setInterval(applyDaypart, 240000);
    }

    var partnerList = locator.querySelector('[data-oat-partner-list]');
    var partnerHeads = Array.from(locator.querySelectorAll('[data-oat-partner-head]'));

    // Every partner figure on this page is counted from the cards themselves.
    // Add one <article> and the tally, the filter chips, the island headings,
    // the summary line and the map pin badges all follow on their own.
    var partnerTotals = { all: partners.length };
    var placeTotals = {};
    partners.forEach(function (partner) {
      (partner.getAttribute('data-regions') || '').split(/\s+/).forEach(function (region) {
        if (region) partnerTotals[region] = (partnerTotals[region] || 0) + 1;
      });
      (partner.getAttribute('data-locations') || '').split(/\s+/).forEach(function (place) {
        if (place) placeTotals[place] = (placeTotals[place] || 0) + 1;
      });
    });

    Object.keys(partnerCopy).forEach(function (key) {
      var total = partnerTotals[key];
      if (typeof total !== 'number') return;
      partnerCopy[key].count = total;
      partnerCopy[key].noun = total === 1 ? 'partner stockist' : 'partner stockists';
    });

    partnerFilters.forEach(function (button) {
      var chip = button.querySelector('span');
      var total = partnerTotals[button.getAttribute('data-oat-partner-filter')];
      if (chip && typeof total === 'number') chip.textContent = total;
    });

    partnerPins.forEach(function (pin) {
      var key = pin.getAttribute('data-oat-partner-location') || pin.getAttribute('data-oat-partner-pin');
      var label = pin.querySelector('b');
      var badge = pin.querySelector('span');
      var place = label ? label.textContent : key;
      var total = placeTotals[key] || 0;
      pin.setAttribute('data-oat-partner-count', total);
      if (badge) badge.textContent = total;
      pin.setAttribute('aria-label', total === 1
        ? 'Show the Oatbedient stockist in ' + place
        : 'Show Oatbedient stockists in ' + place);
    });

    var tally = locator.querySelector('[data-oat-partner-tally]');
    if (tally) {
      // North and south are read off the pin positions, so the sentence keeps
      // pointing at the real ends of the map without anyone editing it.
      var byLatitude = partnerPins.slice().sort(function (a, b) {
        return parseFloat(a.style.getPropertyValue('--pin-y') || 0) - parseFloat(b.style.getPropertyValue('--pin-y') || 0);
      });
      var endpoint = function (pin) {
        if (!pin) return '';
        var label = pin.querySelector('b');
        return pin.getAttribute('data-oat-endpoint') || (label ? label.textContent : '');
      };
      var fill = function (selector, value) {
        var node = tally.querySelector(selector);
        if (node && value !== '' && value !== null) node.textContent = value;
      };
      fill('[data-oat-tally-partners]', partners.length);
      fill('[data-oat-tally-places]', Object.keys(placeTotals).length);
      fill('[data-oat-tally-north]', endpoint(byLatitude[0]));
      fill('[data-oat-tally-south]', endpoint(byLatitude[byLatitude.length - 1]));
    }
    if (partnerList) {
      partners.concat(partnerHeads).sort(function (a, b) {
        var groupDifference = Number(a.getAttribute('data-sort-group') || 9) - Number(b.getAttribute('data-sort-group') || 9);
        if (groupDifference) return groupDifference;
        return (a.getAttribute('data-sort-name') || '').localeCompare(b.getAttribute('data-sort-name') || '', 'en', { sensitivity: 'base' });
      }).forEach(function (card) {
        partnerList.appendChild(card);
      });
    }

    // Island headings only earn their space when something is still listed
    // under them, so a filter never leaves an empty label stranded.
    function syncPartnerHeads() {
      partnerHeads.forEach(function (head) {
        var group = head.getAttribute('data-sort-group');
        var shown = partners.filter(function (partner) {
          return !partner.hidden && partner.getAttribute('data-sort-group') === group;
        }).length;
        head.hidden = shown === 0;
        var tally = head.querySelector('[data-oat-group-count]');
        if (tally) tally.textContent = shown;
      });
    }

    // How Oatdit travels is worked out from the journey itself, so a pin added
    // later behaves sensibly with nothing to configure. A crossing means he
    // sails; staying on the same landmass means he goes overland. A pin may
    // claim its own vessel with data-vessel, and that wins on arrival.
    function vesselFor(fromPin, toPin) {
      var claimed = toPin.getAttribute('data-vessel');
      if (claimed) return claimed;
      // Re-selecting the pin Oatdit is already tied up at is not a journey, so
      // the vessel stays as it is rather than flipping to a land vehicle.
      if (fromPin === toPin) return null;
      var num = function (el, prop) {
        return parseFloat((el.style.getPropertyValue(prop) || '').replace('%', '')) || 0;
      };
      var sameLand = fromPin
        && fromPin.getAttribute('data-landmass')
        && fromPin.getAttribute('data-landmass') === toPin.getAttribute('data-landmass');
      if (!fromPin) return 'boat';
      var span = Math.hypot(num(toPin, '--pin-x') - num(fromPin, '--pin-x'),
                            num(toPin, '--pin-y') - num(fromPin, '--pin-y'));
      if (sameLand) return span < 8 ? 'tricycle' : 'jeepney';
      return span < 16 ? 'bangka' : 'boat';
    }

    var riderPin = null;

    function moveRider(pin) {
      if (!rider || !pin) return;
      var vessel = vesselFor(riderPin, pin);
      if (vessel) {
        rider.setAttribute('data-vessel', vessel);
        rider.setAttribute('data-crossing', vessel === 'jeepney' || vessel === 'tricycle' ? 'land' : 'water');
      }
      riderPin = pin;
      var toX = (pin.style.getPropertyValue('--pin-x') || '').trim();
      var toY = (pin.style.getPropertyValue('--pin-y') || '').trim();
      var travelling = toX !== (rider.style.getPropertyValue('--rider-x') || '').trim()
        || toY !== (rider.style.getPropertyValue('--rider-y') || '').trim();
      rider.style.setProperty('--rider-x', toX);
      rider.style.setProperty('--rider-y', toY);
      rider.classList.remove('is-scooting');
      void rider.offsetWidth;
      rider.classList.add('is-scooting');
      clearTimeout(riderTimer);
      riderTimer = setTimeout(function () {
        rider.classList.remove('is-scooting');
      }, 820);

      // Only ever from a tap or a keypress, never on load, so nothing surprises anyone.
      if (!listening) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var trip = travelling && !reduce ? 600 : 0;
      SailSound.sail(travelling, trip);
      clearTimeout(landTimer);
      landTimer = setTimeout(function () {
        pin.classList.remove('is-arrived');
        void pin.offsetWidth;
        pin.classList.add('is-arrived');
        setTimeout(function () { pin.classList.remove('is-arrived'); }, 700);
      }, trip);
    }

    function selectRegion(region) {
      var copy = regionCopy[region] || regionCopy.all;
      var activePin = null;

      filters.forEach(function (button) {
        var active = button.getAttribute('data-oat-region-filter') === region;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      pins.forEach(function (pin) {
        var active = pin.getAttribute('data-oat-region-pin') === region;
        pin.classList.toggle('is-active', active);
        pin.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) activePin = pin;
      });

      branches.forEach(function (branch) {
        branch.hidden = region !== 'all' && branch.getAttribute('data-region') !== region;
      });

      summary.querySelector('strong').textContent = copy.count + ' ' + copy.noun;
      summary.querySelector('span').textContent = copy.place;
      if (activePin) moveRider(activePin);
    }

    function selectPartnerRegion(region) {
      var copy = partnerCopy[region] || partnerCopy.all;

      partnerFilters.forEach(function (button) {
        var active = button.getAttribute('data-oat-partner-filter') === region;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      partnerPins.forEach(function (pin) {
        var inRegion = region === 'all' || pin.getAttribute('data-oat-partner-region') === region;
        pin.classList.remove('is-active');
        pin.classList.toggle('is-in-region', inRegion);
        pin.setAttribute('aria-pressed', 'false');
      });

      partners.forEach(function (partner) {
        var regions = (partner.getAttribute('data-regions') || '').split(/\s+/);
        partner.hidden = region !== 'all' && regions.indexOf(region) === -1;
      });
      syncPartnerHeads();

      if (partnerSummary) {
        partnerSummary.querySelector('strong').textContent = copy.count + ' ' + copy.noun;
        partnerSummary.querySelector('span').textContent = copy.place;
      }
    }

    function selectPartnerLocation(pin) {
      var location = pin.getAttribute('data-oat-partner-location') || pin.getAttribute('data-oat-partner-pin');
      var place = partnerPlaceCopy[location] || location;
      var count = Number(pin.getAttribute('data-oat-partner-count') || 0);

      partnerFilters.forEach(function (button) {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });
      partnerPins.forEach(function (otherPin) {
        var active = otherPin === pin;
        otherPin.classList.toggle('is-active', active);
        otherPin.classList.add('is-in-region');
        otherPin.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      partners.forEach(function (partner) {
        var locations = (partner.getAttribute('data-locations') || '').split(/\s+/);
        partner.hidden = locations.indexOf(location) === -1;
      });
      syncPartnerHeads();
      if (partnerSummary) {
        partnerSummary.querySelector('strong').textContent = count + ' ' + (count === 1 ? 'partner stockist' : 'partner stockists');
        partnerSummary.querySelector('span').textContent = 'serving ' + place;
      }
      moveRider(pin);
    }

    function selectMode(mode) {
      modes.forEach(function (button) {
        var active = button.getAttribute('data-oat-locator-mode') === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panes.forEach(function (pane) {
        pane.hidden = pane.getAttribute('data-oat-locator-pane') !== mode;
      });
      pins.forEach(function (pin) { pin.hidden = mode !== 'branches'; });
      partnerPins.forEach(function (pin) {
        pin.hidden = mode !== 'partners' || Number(pin.getAttribute('data-oat-partner-count') || 0) === 0;
      });
      if (mode === 'partners') {
        selectPartnerRegion('all');
      } else {
        selectRegion('negros');
      }
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        selectRegion(button.getAttribute('data-oat-region-filter'));
      });
    });

    pins.forEach(function (pin) {
      pin.addEventListener('click', function () {
        selectRegion(pin.getAttribute('data-oat-region-pin'));
      });
    });

    partnerFilters.forEach(function (button) {
      button.addEventListener('click', function () {
        selectPartnerRegion(button.getAttribute('data-oat-partner-filter'));
      });
    });

    partnerPins.forEach(function (pin) {
      pin.addEventListener('click', function () {
        selectPartnerLocation(pin);
      });
    });

    modes.forEach(function (button) {
      button.addEventListener('click', function () {
        selectMode(button.getAttribute('data-oat-locator-mode'));
      });
    });

    if (soundButton) {
      if (!SailSound.available()) {
        soundButton.hidden = true;
      } else {
        var syncSound = function () {
          var on = SailSound.enabled();
          soundButton.setAttribute('aria-pressed', on ? 'true' : 'false');
          soundButton.setAttribute('aria-label', on ? 'Turn the map travel sounds off' : 'Turn the map travel sounds on');
          if (soundLabel) soundLabel.textContent = on ? 'Travel sounds on' : 'Travel sounds off';
        };
        syncSound();
        soundButton.addEventListener('click', function () {
          if (SailSound.enabled() && !SailSound.running()) {
            SailSound.unlock().then(function (unlocked) {
              syncSound();
              if (unlocked) SailSound.chirp();
            });
            return;
          }
          SailSound.set(!SailSound.enabled());
          syncSound();
          if (SailSound.enabled()) {
            SailSound.unlock().then(function (unlocked) {
              if (unlocked) SailSound.chirp();
            });
          }
        });
      }
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearTimeout(landTimer);
    });

    selectMode('branches');
    listening = true;
  });
})();

// Keep the compact Oatbedient page guide in sync with the section in view.
(function () {
  var nav = document.querySelector('[data-oat-page-nav]');
  if (!nav) return;

  // Keep the two shareable Oatbedient destinations on their dedicated
  // Shopify views. This also repairs stale anchor-only markup restored from
  // an older cached section without disturbing the ordinary in-page links.
  document.querySelectorAll('[data-oat-preview-route]').forEach(function (link) {
    var route = link.getAttribute('data-oat-preview-route');
    if (route === 'locator') {
      link.setAttribute('href', '/pages/oatbedient?view=oatlocator&share=v142#find-oatbedient');
    } else if (route === 'game') {
      link.setAttribute('href', '/pages/oatbedient?view=oatorders&share=v142#oatbedient-orders');
    }
  });

  if (!('IntersectionObserver' in window)) return;
  var links = Array.from(nav.querySelectorAll('a[href^="#"]'));
  var targets = links.map(function (link) {
    return document.querySelector(link.getAttribute('href'));
  }).filter(Boolean);
  var observer = new IntersectionObserver(function (entries) {
    var visible = entries.filter(function (entry) { return entry.isIntersecting; })
      .sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; })[0];
    if (!visible) return;
    links.forEach(function (link) {
      var active = link.getAttribute('href') === '#' + visible.target.id;
      if (active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }, { rootMargin: '-22% 0px -62% 0px', threshold: [0, .15, .35] });
  targets.forEach(function (target) { observer.observe(target); });
})();

// Oatbedient gets a little more room to play: a morphing headline,
// a tactile product shake, and a keyboard-friendly pour picker.
(function () {
  document.querySelectorAll('[data-oat-page]').forEach(function (page) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rotate = page.querySelector('[data-oat-rotate]');
    if (rotate && !reduce) {
      var seq = [
        { t: 'the moments we love the most.', f: 'f-brand', hold: 5200 },
        { t: 'busy mornings.', f: 'f-fraunces', hold: 2600 },
        { t: 'weekend brunches.', f: 'f-playfair', hold: 2600 },
        { t: 'slow sips and good coffee.', f: 'f-cormorant', hold: 2800 },
        { t: 'everyday comfort.', f: 'f-dmserif', hold: 2600 },
        { t: 'simple pleasures.', f: 'f-fraunces-i', hold: 2600 },
        { t: 'afternoon catch-ups.', f: 'f-playfair-i', hold: 2600 }
      ];
      var current = 0;
      var nextPhrase = function () {
        rotate.classList.add('is-out');
        setTimeout(function () {
          current = (current + 1) % seq.length;
          rotate.textContent = seq[current].t;
          rotate.className = 'oat-rotate ' + seq[current].f + ' is-out';
          void rotate.offsetWidth;
          rotate.classList.remove('is-out');
          setTimeout(nextPhrase, seq[current].hold);
        }, 520);
      };
      setTimeout(nextPhrase, seq[0].hold);
    }

    var shaker = page.querySelector('[data-oat-shaker]');
    var shakeButton = page.querySelector('[data-oat-shake]');
    var shakeNote = page.querySelector('[data-oat-shake-note]');
    var shakeLines = ['Tiny oat dance complete.', 'Smooth move.', 'Oat mode: on.', 'Shake well. Sip happy.'];
    var shakeIndex = 0;
    if (shaker && shakeButton && shakeNote) {
      shakeButton.addEventListener('click', function () {
        shaker.classList.remove('is-shaking');
        void shaker.offsetWidth;
        shaker.classList.add('is-shaking');
        shakeNote.textContent = shakeLines[shakeIndex % shakeLines.length];
        shakeIndex += 1;
        setTimeout(function () { shaker.classList.remove('is-shaking'); }, 700);
      });
    }

    var options = {
      barista: {
        kicker: 'Barista blend',
        title: "Your coffee's favorite plus-one.",
        text: 'A fuller, creamier body made to froth, foam, and swirl into espresso without stealing the show.',
        points: ['Built for espresso and latte art', 'Rich, rounded texture', 'At home behind a café counter'],
        sticker: 'Froth mode: ON',
        image: 'https://cdn.shopify.com/s/files/1/0424/8207/3758/files/ChatGPT_Image_Jul_4_2026_at_02_52_20_PM.png?v=1783148021&width=1100',
        alt: 'Oatbedient Barista oat milk poured into coffee'
      },
      artisan: {
        kicker: 'Artisan Barista',
        title: 'Your everyday easy oat.',
        text: 'Lighter, smooth, and quietly versatile. Add it to coffee, cereal, smoothies, or simply a glass.',
        points: ['Light and smooth finish', 'Made for everyday sipping', 'Plays nicely with almost anything'],
        sticker: 'Easy does it',
        image: 'https://cdn.shopify.com/s/files/1/0424/8207/3758/files/ChatGPT_Image_Jul_4_2026_at_02_52_38_PM.png?v=1783148021&width=1100',
        alt: 'Oatbedient Artisan Barista oat milk package'
      }
    };
    var tabs = Array.prototype.slice.call(page.querySelectorAll('[data-oat-option]'));
    var panel = page.querySelector('[data-oat-panel]');
    if (!tabs.length || !panel) return;

    var selectPour = function (tab) {
      var choice = options[tab.getAttribute('data-oat-option')];
      if (!choice) return;
      tabs.forEach(function (item) {
        var active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.setAttribute('tabindex', active ? '0' : '-1');
      });
      panel.setAttribute('aria-labelledby', tab.id);
      panel.querySelector('[data-oat-kicker]').textContent = choice.kicker;
      panel.querySelector('[data-oat-title]').textContent = choice.title;
      panel.querySelector('[data-oat-text]').textContent = choice.text;
      panel.querySelector('[data-oat-sticker]').textContent = choice.sticker;
      var image = panel.querySelector('[data-oat-image]');
      image.src = choice.image;
      image.alt = choice.alt;
      var points = panel.querySelector('[data-oat-points]');
      points.innerHTML = '';
      choice.points.forEach(function (point) {
        var li = document.createElement('li');
        li.textContent = point;
        points.appendChild(li);
      });
      panel.classList.remove('is-changing');
      void panel.offsetWidth;
      panel.classList.add('is-changing');
    };

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { selectPour(tab); });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var next = tabs[(index + direction + tabs.length) % tabs.length];
        selectPour(next);
        next.focus();
      });
    });

    page.querySelectorAll('[data-oat-mascot-react]').forEach(function (mascot) {
      var timer;
      mascot.addEventListener('click', function () {
        mascot.classList.remove('is-reacting');
        void mascot.offsetWidth;
        mascot.classList.add('is-reacting');
        clearTimeout(timer);
        timer = setTimeout(function () { mascot.classList.remove('is-reacting'); }, 1100);
      });
      mascot.addEventListener('animationend', function (event) {
        if (mascot.classList.contains('is-reacting') && event.animationName.indexOf('react') !== -1) {
          mascot.classList.remove('is-reacting');
        }
      });
    });
  });
})();
